import axios from "axios";
import {toast} from './Notification'
import store from '@/store'

axios.defaults.baseURL = 'https://api.zehneboursi.ir/api/';
axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`

let requestCounter = 0

axios.interceptors.request.use(function (config) {
    requestCounter += 1
    store.commit('Loading/setStatus', true)
    return config
})

axios.interceptors.response.use(
    response => {
        requestCounter -= 1

        setTimeout(() => {
            if (requestCounter <= 0) {
                store.commit('Loading/setStatus', false)
            }
        }, 0)

        return response
    },
    error => {


        if (typeof error.response.data.message == 'string') {
            toast(error.response.data.status, error.response.data.message, 'danger')
        } else {
            const errors = error.response.data.message;
            for (const e in errors) {
                errors[e].forEach(item => {

                    toast(error.response.data.status, item, 'danger')

                })
            }
        }
        requestCounter -= 1
        if (requestCounter <= 0) {
            store.commit('Loading/setStatus', false)
        }
        return Promise.reject(error)
    },
);